module.exports = __webpack_public_path__ + "4f1f65f13876025611dbb840adc82ef9.jpg";